type DraftState = {
  hasUnsentComment?: boolean;
  draftComment?: { ticketId: number | string } | null;
};

/**
 * The open ticket has a comment not yet sent: in its comment box, or put away while its activity
 * tab is closed (the box unmounts with the tab). Ids are compared as numbers, as one side comes
 * from the route and is a string.
 */
export const hasUnsentDraft = (state: DraftState, ticketId: number | string): boolean =>
  !!state.hasUnsentComment ||
  (state.draftComment != null && Number(state.draftComment.ticketId) === Number(ticketId));
